import { Pass } from 'postprocessing'
import Material from './Material.js'

export default class RGBOffsetPass extends Pass
{
    constructor(_options = {})
    {
        super('RGBOffset')

        this.material = new Material()

        this.material.uniforms.uResolution.value = _options.resolution
        this.material.uniforms.uStrength.value = _options.strength
        this.material.uniforms.uRadialDumping.value = _options.radialDumping
        this.material.uniforms.uTeint.value = _options.teint
    }

    render(renderer, inputBuffer, outputBuffer, delta, stencilTest)
    {
        this.material.uniforms.tDiffuse.value = inputBuffer.texture
        renderer.render(this.scene, this.camera, this.renderToScreen ? null : outputBuffer)
    }

    setSize(width, height)
    {
        this.material.uniforms.uResolution.value.x = width
        this.material.uniforms.uResolution.value.y = height
    }
}



// WEBPACK FOOTER //
// ./src/components/app-experience/Experience/Passes/RGBOffsetPass/index.js